module.exports = __webpack_public_path__ + "static/img/200092.960c02d6.png";